import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=67d47932&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=67d47932&prod&lang=scss"
import style1 from "./privacy.vue?vue&type=style&index=1&id=67d47932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d47932",
  null
  
)

export default component.exports